<div class="wrapper">
  <!-- <app-sidebar class="hidden-xs"></app-sidebar> -->
  <app-sidebar></app-sidebar>

  <div id="content">
    @if (!!i_currentJob) {
      <div class="content__title">
        <div class="responsive-flex-container">
          <div class="responsive-flex-item">
            <h1 style="margin-right: 10px; display: flex; align-items: center; margin-bottom: 0px;">
              <span style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; " class="project-title">
                <span style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;"
                  class="actions__item" (click)="navigateToProjectTable()">{{
                  i_currentJob.projectName
                }}</span>
              </span>
              @if (project) {
                <span class="actions" style="flex-shrink: 0; margin-left: 8px;"
                  >
                  <button class="actions__item zmdi zmdi-edit" (click)="openProjectDialog()"></button>
                </span>
              }
            </h1>
          </div>
          <div style="display: flex; align-items: center;">
            <div class="job-status" style="margin-right: 20px; margin-top: 2px; white-space: nowrap">
              @if (!isMobile) {
                <h2 [matTooltip]="parentJobFullStr">
                  {{ parentJobDisplayStr && "Parent Job: " + parentJobDisplayStr}}
                </h2>
              }
            </div>
            <div style="margin-top: 2px; margin-right: 10px">
              @if (showCountDown()) {
                <span style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
                  [matTooltip]="'Clean Up in ' + getJobCleanUpCountDown() + ' days'">Storage
                Status: {{ getJobArchiveStatus() }}</span>
              }
              @if (!showCountDown()) {
                <span style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
                >Storage Status: {{ getJobArchiveStatus() }}</span>
              }
            </div>
            <div style="cursor: pointer; margin-top: 2px; margin-right: 10px" class="keep-job">
              <span style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" class="actions__item"
              (click)="keep_job()">Keep Job: {{ i_currentJob.keep_job }}</span>
            </div>
            @if (isReloadingJob) {
              <div>
                <mat-spinner mode="indeterminate" color="primary" diameter="20"></mat-spinner>
              </div>
            }
            <button [style.margin-right]="isMobile ? '10px' : '20px'" class="job-status" (click)="refreshJobs()">
              <i class="zmdi zmdi-refresh"></i>
              @if (!isMobile) {
                <span class="job-status">{{ isReloadingJob ? "Refreshing Jobs" :
                "Refresh Jobs" }}</span>
              }
            </button>
            <div [style.margin-right]="isMobile ? '10px' : '20px'"
              style="min-width: 0; max-width: 100%; margin-bottom: 0px;">
              <mat-checkbox class="job-status" [(ngModel)]="synchroniseSettings"
                (ngModelChange)="onSynchroniseChange($event)">{{
                isCompactView ? "Sync Settings" : "Synchronise Settings"
              }}</mat-checkbox>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 10px">
          <small style="display: block">
            {{ i_currentJob.projectDescription }}
          </small>
        </div>
        <div class="row" style="margin: 0px;">
          <div class="col-sm-12" style="padding: 0px">
            <div class="popular-tab-container">
              <div class="btn-group">
                <button mat-raised-button matcolor="blue" (click)="addTab()">
                  <i class="zmdi zmdi-plus"></i>
                </button>
                <button mat-raised-button matcolor="blue" [disabled]="popularJobs.length === 0" (click)="removeTab()">
                  <i class="zmdi zmdi-minus"></i>
                </button>
                <button mat-raised-button matcolor="blue" [disabled]="popularJobs.length === 0" (click)="shiftLeft()">
                  <i class="zmdi zmdi-arrow-back"></i>
                </button>
                <button mat-raised-button matcolor="blue" [disabled]="popularJobs.length === 0" (click)="shiftRight()">
                  <i class="zmdi zmdi-arrow-forward"></i>
                </button>
              </div>
              @if (popularJobs.length > 0) {
                <mat-tab-group [ngClass]="{'no-indicator-tabs': !isCurrentJobInPopularJobs()}"
                  [ngStyle]="{'border-top': popularJobs.length > 0 ? '1px solid #ccc' : 'none'}" id="tab-bar-popular"
                  [selectedIndex]="i_popularIndex" mat-stretch-tabs="false" mat-align-tabs="start">
                  @for (job of popularJobs; track trackByJobId(i, job); let i = $index) {
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <div (click)="onIndexChangedHandler(i, 'fav')"
                          style="width: 100%; height: 100%; display: flex; flex-direction: row; align-items: center; justify-content: center">
                          @if (job.status == 'RUNNING') {
                            <span>
                              <i class="zmdi zmdi-play"></i>&nbsp;
                            </span>
                          }
                          <span [title]="job.name">
                            {{ job.name.substr(0, 7) }}
                          </span>
                          @if (
                            job.id === i_currentJob.id
                            ) {
                            <div class="actions">
                              <button class="actions__item zmdi zmdi-edit" (click)="openJobDialog(true)"></button>
                            </div>
                          }
                        </div>
                      </ng-template>
                    </mat-tab>
                  }
                </mat-tab-group>
              }
            </div>
          <div style="
              display: flex;
              justify-content: space-between;
              border-bottom: 1px solid #ccc;
              border-top: 1px solid #ccc;
            ">
              <div style="overflow: auto; width: 80%">
                @if (jobs && i_currentJob) {
                  <mat-tab-group id="tab-bar"
                [selectedIndex]="jobs | findJobIndex: i_currentJob.id" style="
                  border-color: #ccc;
                  border-style: solid;
                  border-width: 0px 1px 0px 0px;
                " mat-stretch-tabs="false" mat-align-tabs="start"
                    (selectedIndexChange)="onIndexChangedHandler($event, 'all')">
                    @for (job of jobs; track trackByJobId(i, job); let i = $index) {
                      <mat-tab [label]="job.name">
                      </mat-tab>
                    }
                  </mat-tab-group>
                }
              </div>
              @if (!isMobile) {
                <div style="padding-left: 5px;" class="job-select">
                  <label style="margin-right: 5px">Selected Job</label>
                  <nz-select nzShowSearch [(ngModel)]="this.i_currentJob" [compareWith]="compareFn" style="width: 300px"
                    (ngModelChange)="onHandleJobChange()">
                    <!-- (ngModelChange)="menuSelected2($event)" -->
                    @for (job of jobs; track trackByJobId(i, job); let i = $index) {
                      <nz-option [nzValue]="job"
                        [nzLabel]="job.name" nzCustomContent>
                  <span style="
                      height: 10px;
                      width: 10px;
                      border-radius: 5px;
                      display: inline-block;
                      background-color: blue;
                    " [style.backgroundColor]="
                      job.type == 'QC'
                        ? 'oklch(90.5% 0.182 98.111)'
                        : job.type == 'SC'
                        ? 'oklch(58.6% 0.253 17.585)'
                        : job.type == 'standard'
                        ? '#2196F3'
                        : job.type == 'RWI' 
                        ? 'oklch(75% 0.183 55.934)'
                        : 'oklch(69.6% 0.17 162.48)'
                    "></span>
                        {{job.name}}
                      </nz-option>
                    }
                  </nz-select>
                  <button nz-button nz-dropdown [nzDropdownMenu]="groupsMenu">
                    <span nz-icon nzType="ellipsis"></span>
                  </button>
                  <nz-dropdown-menu #groupsMenu="nzDropdownMenu">
                    <ul nz-menu>
                      @for (jobGroup of this.jobGroups; track jobGroup) {
                        <li nz-submenu [nzTitle]="jobGroup.name" [nzClickHide]="false"
                          (click)="onGroupClick(jobGroup)">
                          <ul>
                            @for (job of jobGroup.jobs; track trackByJobId($index, job)) {
                              <li nz-menu-item [nzDisabled]="true">
                                {{ job.job__job_name }}
                              </li>
                            }
                          </ul>
                        </li>
                      }
                    </ul>
                  </nz-dropdown-menu>
                  <div class="actions">
                    <button class="actions__item zmdi zmdi-edit" (click)="openJobDialog(false)"></button>
                  </div>
                </div>
              }
              <!-- on mobile / window with small width -->
              @if (isMobile) {
                <div class="job-select">
                  <button [matMenuTriggerFor]="jobMenu" #menuTriger="matMenuTrigger"
                    (click)="menuOpen(menuTrigger, $event)">
                    Job Select
                  </button>
                  <div class="actions">
                    <button class="actions__item zmdi zmdi-edit" (click)="openJobDialog(false)"></button>
                  </div>
                  <mat-menu class="long-menu-narrow" #jobMenu="matMenu">
                    @for (job of jobs; track trackByJobId(i, job); let i = $index) {
                      <button class="job-select-menu-item-narrow" mat-menu-item #menuItem="matMenuItem"
                        (click)="menuSelected(menuItem, i, $event)">
                        {{ job.name }}
                      </button>
                    }
                  </mat-menu>
                </div>
              }
            </div>
          </div>
          <!-- <div class="col-sm-12 job-error" *ngIf="!!jobs">
          {{ jobs[selectedIndex].last_error_status }}
        </div> -->
      </div>
    </div>
  }
  <router-outlet></router-outlet>

  <div class="projects-bar-popular" [ngClass]="{ visible: tabBarVisible, emptyTab: tabIsEmpty }">
    <div class="btn-group" [ngClass]="{ visible: tabBarVisible, emptyTab: tabIsEmpty }">
      <button mat-raised-button matcolor="blue" (click)="addTab()">
        <i class="zmdi zmdi-plus"></i>
      </button>
      <button mat-raised-button matcolor="blue" [disabled]="popularJobs.length === 0" (click)="removeTab()">
        <i class="zmdi zmdi-minus"></i>
      </button>
      <button mat-raised-button matcolor="blue" [disabled]="popularJobs.length === 0" (click)="shiftLeft()">
        <i class="zmdi zmdi-arrow-back"></i>
      </button>
      <button mat-raised-button matcolor="blue" [disabled]="popularJobs.length === 0" (click)="shiftRight()">
        <i class="zmdi zmdi-arrow-forward"></i>
      </button>
    </div>

    @if (popularJobs.length > 0) {
      <mat-tab-group [ngClass]="{'no-indicator-tabs': !isCurrentJobInPopularJobs()}" [selectedIndex]="i_popularIndex"
        mat-stretch-tabs="false" mat-align-tabs="start">
        @for (job of popularJobs; track trackByJobId(i, job); let i = $index) {
          <mat-tab>
            <ng-template mat-tab-label>
              <div (click)="onIndexChangedHandler(i, 'fav')"
                style="width: 100%; height: 100%; display: flex; flex-direction: row; align-items: center; justify-content: center">
                @if (job.status == 'RUNNING') {
                  <span>
                    <i class="zmdi zmdi-play"></i>&nbsp;
                  </span>
                }
                <span [title]="job.name">
                  {{ job.name.substr(0, 7) }}
                </span>
              </div>
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    }
    <div class="projects-bar" [ngClass]="{ visible: tabBarVisible }">
      <div class="col-md-10">
        @if (jobs && i_currentJob) {
          <mat-tab-group [selectedIndex]="jobs | findJobIndex: i_currentJob.id"
            mat-stretch-tabs="false" mat-align-tabs="start" (selectedIndexChange)="onIndexChangedHandler($event, 'all')">
            @for (job of jobs; track trackByJobId(i, job); let i = $index) {
              <mat-tab [label]="job.name">
              </mat-tab>
            }
          </mat-tab-group>
        }
      </div>
      <div class="col-md-2 sync-settings hidden-xs">
        <div class="">
          <mat-checkbox class="job-status" style="margin-top: 10px" [(ngModel)]="synchroniseSettings"
          (ngModelChange)="onSynchroniseChange($event)">Synchronise Settings</mat-checkbox>
        </div>
      </div>
    </div>
  </div>
</div>
</div>